
import React from 'react'
import '../../layouts/account/account.scss';


export function HelpPage() {

  return (
    <div className="features-content" >
      <iframe src="https://help.officely.ai/kb" width="100%" height="100%"></iframe>
    </div>

  )
}
